import React from 'react';

// FIXME: some constants should be placed to API
// This file is a set of constants moved from filters.jsx.erb.txt that we will use all over the project
// Tip: used to be this: `let clarity_values = "{"FL":68,"FL-IF":69,"IF":70,"IF-VVS1":71,"VVS1":72,"VVS1-VVS2":73,"VVS2":74,"VVS2-VS1":75,"VS1":76,"VS1-VS2":77,"VS2":78,"VS2-SI1":79,"SI1":80,"SI1-SI2":81,"SI2":82,"SI2-I1":958,"SI2-SI3":83,"SI3":84,"SI3-I1":85,"I1":86,"I1-I2":87,"I2":88,"I2-I3":89,"I3":90,"Not Sure":91,"N/A":1261} || {}";`
import _ from 'lodash';

// noinspection JSAnnotator
export const clarity_values = {"FL":68,"FL-IF":69,"IF":70,"IF-VVS1":71,"VVS1":72,"VVS1-VVS2":73,"VVS2":74,"VVS2-VS1":75,"VS1":76,"VS1-VS2":77,"VS2":78,"VS2-SI1":79,"SI1":80,"SI1-SI2":81,"SI2":82,"SI2-I1":958,"SI2-SI3":83,"SI3":84,"SI3-I1":85,"I1":86,"I1-I2":87,"I2":88,"I2-I3":89,"I3":90,"Not Sure":91,"N/A":1261} || {}
// noinspection JSAnnotator
export const avg_clarity_values = {"FL":199,"FL-IF":200,"IF":201,"IF-VVS1":202,"VVS1":203,"VVS1-VVS2":204,"VVS2":205,"VVS2-VS1":206,"VS1":207,"VS1-VS2":208,"VS2":209,"VS2-SI1":210,"SI1":211,"SI1-SI2":212,"SI2":213,"SI2-I1":959,"SI2-SI3":214,"SI3":215,"SI3-I1":216,"I1":217,"I1-I2":218,"I2":219,"I2-I3":220,"Not Sure":782,"I3":221,"N/A":1263} || {}
// noinspection JSAnnotator
export const color_values = {"D":41,"D-E":42,"E":43,"E-F":44,"F":45,"F-G":46,"G":47,"G-H":48,"H":49,"H-I":50,"I":51,"I-J":52,"J":53,"J-K":54,"K":55,"K-L":56,"L":57,"L-M":58,"M":779,"M-Z":59,"Fancy":60,"Not Sure":61,"N/A":1260} || {}
// noinspection JSAnnotator
export const avg_color_values = {"D":179,"D-E":180,"E":181,"E-F":182,"F":183,"F-G":184,"G":185,"G-H":186,"H":187,"H-I":188,"I":189,"I-J":190,"J":191,"J-K":192,"K":193,"K-L":194,"L":195,"L-M":196,"M":197,"M-Z":780,"Not Sure":781,"Fancy":198,"N/A":1262} || {}

export const FILTER_OPTIONS = {
    // TODO: move to model and fix those queries
    jewelry_types: [{"id":5,"system_name":"jewelry_rings","pretty_name":"Ring"},{"id":6,"system_name":"jewelry_earrings","pretty_name":"Earrings"},{"id":7,"system_name":"jewelry_bracelets","pretty_name":"Bracelet"},{"id":8,"system_name":"jewelry_necklaces","pretty_name":"Necklace"},{"id":24,"system_name":"jewelry_miscellaneous","pretty_name":"Miscellaneous"}],
    jewelry_brands: [{"id":981,"system_name":"jewelry_brand_bvlgari","pretty_name":"Bvlgari"},{"id":982,"system_name":"jewelry_brand_cartier","pretty_name":"Cartier"},{"id":986,"system_name":"jewelry_brand_harry_winston","pretty_name":"Harry Winston"},{"id":990,"system_name":"jewelry_brand_tiffany_co","pretty_name":"Tiffany \u0026 Co."},{"id":992,"system_name":"jewelry_brand_van_cleef_arpels","pretty_name":"Van Cleef \u0026 Arpels"}],
    certificates: [{"id":222,"system_name":"diamond_certificate_gia","pretty_name":"GIA"},{"id":225,"system_name":"diamond_certificate_igi","pretty_name":"IGI"}],
    shapes: {
        all: [{"id":8,"system_name":"diamond_shape_round","pretty_name":"Round"},{"id":9,"system_name":"diamond_shape_pear","pretty_name":"Pear"},{"id":10,"system_name":"diamond_shape_emerald","pretty_name":"Emerald"},{"id":11,"system_name":"diamond_shape_marquise","pretty_name":"Marquise"},{"id":12,"system_name":"diamond_shape_oval","pretty_name":"Oval"},{"id":13,"system_name":"diamond_shape_radiant","pretty_name":"Radiant"},{"id":14,"system_name":"diamond_shape_princess","pretty_name":"Princess"},{"id":15,"system_name":"diamond_shape_trilliant","pretty_name":"Trilliant"},{"id":16,"system_name":"diamond_shape_heart","pretty_name":"Heart"},{"id":17,"system_name":"diamond_shape_european_cut","pretty_name":"European Cut"},{"id":18,"system_name":"diamond_shape_old_mine","pretty_name":"Old Mine"},{"id":19,"system_name":"diamond_shape_flanders","pretty_name":"Flanders"},{"id":20,"system_name":"diamond_shape_cushion","pretty_name":"Cushion"},{"id":21,"system_name":"diamond_shape_asscher","pretty_name":"Asscher"},{"id":22,"system_name":"diamond_shape_baguette","pretty_name":"Baguette"},{"id":23,"system_name":"diamond_shape_kite","pretty_name":"Kite"},{"id":24,"system_name":"diamond_shape_star","pretty_name":"Star"},{"id":26,"system_name":"diamond_shape_half_moon","pretty_name":"Half Moon"},{"id":27,"system_name":"diamond_shape_trapezoid","pretty_name":"Trapezoid"},{"id":28,"system_name":"diamond_shape_bullets","pretty_name":"Bullets"},{"id":29,"system_name":"diamond_shape_hexagonal","pretty_name":"Hexagonal"},{"id":30,"system_name":"diamond_shape_lozenge","pretty_name":"Lozenge"},{"id":31,"system_name":"diamond_shape_pentagonal","pretty_name":"Pentagonal"},{"id":32,"system_name":"diamond_shape_rose","pretty_name":"Rose"},{"id":33,"system_name":"diamond_shape_shield","pretty_name":"Shield"},{"id":34,"system_name":"diamond_shape_square","pretty_name":"Square"},{"id":35,"system_name":"diamond_shape_triangular","pretty_name":"Triangular"},{"id":36,"system_name":"diamond_shape_square_emerald","pretty_name":"Square Emerald"},{"id":37,"system_name":"diamond_shape_cushion_modified","pretty_name":"Cushion Modified"},{"id":38,"system_name":"diamond_shape_briolette","pretty_name":"Briolette"},{"id":39,"system_name":"diamond_shape_octagonal","pretty_name":"Octagonal"},{"id":955,"system_name":"diamond_shape_lucere","pretty_name":"Lucere"},{"id":1000,"system_name":"diamond_shape_single","pretty_name":"Single"},{"id":1012,"system_name":"diamond_shape_free_form","pretty_name":"Free Form"},{"id":25,"system_name":"diamond_shape_other","pretty_name":"Other"},{"id":1095,"system_name":"diamond_shape_shield_modified","pretty_name":"Shield Modified"},{"id":1096,"system_name":"diamond_shape_round_modified","pretty_name":"Round Modified"},{"id":1097,"system_name":"diamond_shape_single_cut","pretty_name":"Single Cut"},{"id":1098,"system_name":"diamond_shape_flower","pretty_name":"Flower"},{"id":1099,"system_name":"diamond_shape_octagonal_modified","pretty_name":"Octagonal Modified"},{"id":1100,"system_name":"diamond_shape_oval_modified","pretty_name":"Oval Modified"},{"id":1101,"system_name":"diamond_shape_oval_rose","pretty_name":"Oval Rose"},{"id":1102,"system_name":"diamond_shape_rose_cushion","pretty_name":"Rose Cushion"},{"id":1103,"system_name":"diamond_shape_pair","pretty_name":"Pair"},{"id":1104,"system_name":"diamond_shape_triangle","pretty_name":"Triangle"},{"id":1105,"system_name":"diamond_shape_pear_modified","pretty_name":"Pear Modified"},{"id":1106,"system_name":"diamond_shape_rectangular_rose","pretty_name":"Rectangular Rose"},{"id":1107,"system_name":"diamond_shape_marquise_rose","pretty_name":"Marquise Rose"},{"id":1108,"system_name":"diamond_shape_heart_rose","pretty_name":"Heart Rose"},{"id":1110,"system_name":"diamond_shape_tapered_baguette","pretty_name":"Tapered Baguette"},{"id":1111,"system_name":"diamond_shape_square_modified","pretty_name":"Square Modified"},{"id":1112,"system_name":"diamond_shape_rose_triangular","pretty_name":"Rose Triangular"},{"id":1113,"system_name":"diamond_shape_rose_pear","pretty_name":"Rose Pear"},{"id":1114,"system_name":"diamond_shape_modified_cushion","pretty_name":"Modified Cushion"},{"id":1115,"system_name":"diamond_shape_decagonal","pretty_name":"Decagonal"},{"id":1116,"system_name":"diamond_shape_rise_rectangle","pretty_name":"Rise Rectangle"},{"id":1117,"system_name":"diamond_shape_rose_marquise","pretty_name":"Rose Marquise"},{"id":1118,"system_name":"diamond_shape_old_european","pretty_name":"Old European"},{"id":1119,"system_name":"diamond_shape_rose_heart","pretty_name":"Rose Heart"},{"id":1120,"system_name":"diamond_shape_rose_oval","pretty_name":"Rose Oval"},{"id":1121,"system_name":"diamond_shape_rose_shield","pretty_name":"Rose Shield"},{"id":1123,"system_name":"diamond_shape_rose_round","pretty_name":"Rose Round"},{"id":1124,"system_name":"diamond_shape_radiant_modified","pretty_name":"Radiant Modified"},{"id":1125,"system_name":"diamond_shape_lozenge_modified","pretty_name":"Lozenge Modified"},{"id":1126,"system_name":"diamond_shape_emerald_modified","pretty_name":"Emerald Modified"},{"id":1127,"system_name":"diamond_shape_heart_modified","pretty_name":"Heart Modified"},{"id":1128,"system_name":"diamond_shape_triangular_modified","pretty_name":"Triangular Modified"},{"id":1129,"system_name":"diamond_shape_trapezoid_modified","pretty_name":"Trapezoid Modified"},{"id":1130,"system_name":"diamond_shape_rose_hexagonal","pretty_name":"Rose Hexagonal"},{"id":1131,"system_name":"diamond_shape_cross","pretty_name":"Cross"},{"id":1132,"system_name":"diamond_shape_bead","pretty_name":"Bead"},{"id":1134,"system_name":"diamond_shape_circular_brilliant_cut","pretty_name":"Circular Brilliant Cut"},{"id":1135,"system_name":"diamond_shape_round_modified_brilliant","pretty_name":"Round Modified Brilliant"},{"id":1136,"system_name":"diamond_shape_rose_other","pretty_name":"Rose Other"},{"id":1137,"system_name":"diamond_shape_rose_half_moon","pretty_name":"Rose Half Moon"},{"id":1138,"system_name":"diamond_shape_rose_kite","pretty_name":"Rose Kite"},{"id":1211,"system_name":"diamond_shape_emerald_step","pretty_name":"Emerald Step"},{"id":1212,"system_name":"diamond_shape_transitional_cut","pretty_name":"Transitional Cut"},{"id":1213,"system_name":"diamond_shape_circular_brilliant","pretty_name":"Circular Brilliant"}],
        jewelry: []
    },
    color: [{"id":41,"system_name":"diamond_color_d","pretty_name":"D"},{"id":42,"system_name":"diamond_color_d_e","pretty_name":"D-E"},{"id":43,"system_name":"diamond_color_e","pretty_name":"E"},{"id":44,"system_name":"diamond_color_e_f","pretty_name":"E-F"},{"id":45,"system_name":"diamond_color_f","pretty_name":"F"},{"id":46,"system_name":"diamond_color_f_g","pretty_name":"F-G"},{"id":47,"system_name":"diamond_color_g","pretty_name":"G"},{"id":48,"system_name":"diamond_color_g_h","pretty_name":"G-H"},{"id":49,"system_name":"diamond_color_h","pretty_name":"H"},{"id":50,"system_name":"diamond_color_h_i","pretty_name":"H-I"},{"id":51,"system_name":"diamond_color_i","pretty_name":"I"},{"id":52,"system_name":"diamond_color_i_j","pretty_name":"I-J"},{"id":53,"system_name":"diamond_color_j","pretty_name":"J"},{"id":54,"system_name":"diamond_color_j_k","pretty_name":"J-K"},{"id":55,"system_name":"diamond_color_k","pretty_name":"K"},{"id":56,"system_name":"diamond_color_k_l","pretty_name":"K-L"},{"id":57,"system_name":"diamond_color_l","pretty_name":"L"},{"id":58,"system_name":"diamond_color_l_m","pretty_name":"L-M"},{"id":779,"system_name":"diamond_color_m","pretty_name":"M"},{"id":59,"system_name":"diamond_color_m_z","pretty_name":"M-Z"},{"id":60,"system_name":"diamond_color_fancy","pretty_name":"Fancy"},{"id":61,"system_name":"diamond_color_not_sure","pretty_name":"Not Sure"},{"id":1260,"system_name":"diamond_color_na","pretty_name":"N/A"}],
    clarity: [{"id":68,"system_name":"diamond_clarity_fl","pretty_name":"FL"},{"id":69,"system_name":"diamond_clarity_fl_if","pretty_name":"FL-IF"},{"id":70,"system_name":"diamond_clarity_if","pretty_name":"IF"},{"id":71,"system_name":"diamond_clarity_if_vvs1","pretty_name":"IF-VVS1"},{"id":72,"system_name":"diamond_clarity_vvs1","pretty_name":"VVS1"},{"id":73,"system_name":"diamond_clarity_vvs1_vvs2","pretty_name":"VVS1-VVS2"},{"id":74,"system_name":"diamond_clarity_vvs2","pretty_name":"VVS2"},{"id":75,"system_name":"diamond_clarity_vvs2_vs1","pretty_name":"VVS2-VS1"},{"id":76,"system_name":"diamond_clarity_vs1","pretty_name":"VS1"},{"id":77,"system_name":"diamond_clarity_vs1_vs2","pretty_name":"VS1-VS2"},{"id":78,"system_name":"diamond_clarity_vs2","pretty_name":"VS2"},{"id":79,"system_name":"diamond_clarity_vs2_si1","pretty_name":"VS2-SI1"},{"id":80,"system_name":"diamond_clarity_si1","pretty_name":"SI1"},{"id":81,"system_name":"diamond_clarity_si1_si2","pretty_name":"SI1-SI2"},{"id":82,"system_name":"diamond_clarity_si2","pretty_name":"SI2"},{"id":958,"system_name":"diamond_clarity_si2_i1","pretty_name":"SI2-I1"},{"id":83,"system_name":"diamond_clarity_si2_si3","pretty_name":"SI2-SI3"},{"id":84,"system_name":"diamond_clarity_si3","pretty_name":"SI3"},{"id":85,"system_name":"diamond_clarity_si3_i1","pretty_name":"SI3-I1"},{"id":86,"system_name":"diamond_clarity_i1","pretty_name":"I1"},{"id":87,"system_name":"diamond_clarity_i1_i2","pretty_name":"I1-I2"},{"id":88,"system_name":"diamond_clarity_i2","pretty_name":"I2"},{"id":89,"system_name":"diamond_clarity_i2_i3","pretty_name":"I2-I3"},{"id":90,"system_name":"diamond_clarity_i3","pretty_name":"I3"},{"id":91,"system_name":"diamond_clarity_not_sure","pretty_name":"Not Sure"},{"id":1261,"system_name":"diamond_clarity_na","pretty_name":"N/A"}],
    brands: [{"id":381,"system_name":"luxury_watch_brand_alain_siberstein","pretty_name":"Alain Siberstein"},{"id":382,"system_name":"luxury_watch_brand_andersen_genève","pretty_name":"Andersen Genève"},{"id":1270,"system_name":"luxury_watch_brand_andre_pailet","pretty_name":"Andre Pailet"},{"id":383,"system_name":"luxury_watch_brand_arnold_son","pretty_name":"Arnold \u0026 Son"},{"id":384,"system_name":"luxury_watch_brand_audemars_piguet","pretty_name":"Audemars Piguet"},{"id":385,"system_name":"luxury_watch_brand_ball","pretty_name":"Ball"},{"id":386,"system_name":"luxury_watch_brand_baume_mercier","pretty_name":"Baume \u0026 Mercier"},{"id":994,"system_name":"luxury_watch_brand_bedat_co","pretty_name":"Bedat \u0026 Co"},{"id":387,"system_name":"luxury_watch_brand_bell_ross","pretty_name":"Bell \u0026 Ross"},{"id":388,"system_name":"luxury_watch_brand_blancpain","pretty_name":"Blancpain"},{"id":1010,"system_name":"luxury_watch_brand_boucheron","pretty_name":"Boucheron"},{"id":389,"system_name":"luxury_watch_brand_bovet","pretty_name":"Bovet"},{"id":390,"system_name":"luxury_watch_brand_breguet","pretty_name":"Breguet"},{"id":391,"system_name":"luxury_watch_brand_breitling","pretty_name":"Breitling"},{"id":392,"system_name":"luxury_watch_brand_bulgari","pretty_name":"Bulgari"},{"id":1068,"system_name":"luxury_watch_brand_bulova","pretty_name":"Bulova"},{"id":1210,"system_name":"luxury_watch_brand_carl_f_bucherer","pretty_name":"Carl F. Bucherer"},{"id":393,"system_name":"luxury_watch_brand_cartier","pretty_name":"Cartier"},{"id":394,"system_name":"luxury_watch_brand_chanel","pretty_name":"Chanel"},{"id":395,"system_name":"luxury_watch_brand_chopard","pretty_name":"Chopard"},{"id":1063,"system_name":"luxury_watch_brand_concord","pretty_name":"Concord"},{"id":396,"system_name":"luxury_watch_brand_corum","pretty_name":"Corum"},{"id":1065,"system_name":"luxury_watch_brand_croton","pretty_name":"Croton"},{"id":1147,"system_name":"luxury_watch_brand_david_yurman","pretty_name":"David Yurman"},{"id":397,"system_name":"luxury_watch_brand_de_bethune","pretty_name":"De Bethune"},{"id":398,"system_name":"luxury_watch_brand_de_grisogono","pretty_name":"De Grisogono"},{"id":399,"system_name":"luxury_watch_brand_dewitt","pretty_name":"Dewitt"},{"id":400,"system_name":"luxury_watch_brand_dimier","pretty_name":"Dimier"},{"id":1139,"system_name":"luxury_watch_brand_ebel","pretty_name":"Ebel"},{"id":1067,"system_name":"luxury_watch_brand_ekegren","pretty_name":"Ekegren"},{"id":1156,"system_name":"luxury_watch_brand_elgin","pretty_name":"Elgin"},{"id":401,"system_name":"luxury_watch_brand_fp_journe","pretty_name":"F.P. Journe"},{"id":402,"system_name":"luxury_watch_brand_franc_vila","pretty_name":"FRANC VILA"},{"id":1011,"system_name":"luxury_watch_brand_georg_jensen","pretty_name":"Georg Jensen"},{"id":403,"system_name":"luxury_watch_brand_franck_muller","pretty_name":"Franck Muller"},{"id":405,"system_name":"luxury_watch_brand_girard_perregaux","pretty_name":"Girard-Perregaux"},{"id":406,"system_name":"luxury_watch_brand_glashütte_original","pretty_name":"Glashütte Original"},{"id":407,"system_name":"luxury_watch_brand_graham","pretty_name":"Graham"},{"id":408,"system_name":"luxury_watch_brand_greubel_forsey","pretty_name":"Greubel Forsey"},{"id":404,"system_name":"luxury_watch_brand_gérald_genta","pretty_name":"Gérald Genta"},{"id":1005,"system_name":"luxury_watch_brand_hamilton","pretty_name":"Hamilton"},{"id":409,"system_name":"luxury_watch_brand_harry_winston","pretty_name":"Harry Winston"},{"id":410,"system_name":"luxury_watch_brand_hautlence","pretty_name":"Hautlence"},{"id":411,"system_name":"luxury_watch_brand_hermès","pretty_name":"Hermès"},{"id":1269,"system_name":"luxury_watch_brand_heuer","pretty_name":"Heuer"},{"id":412,"system_name":"luxury_watch_brand_hublot","pretty_name":"Hublot"},{"id":413,"system_name":"luxury_watch_brand_iwc","pretty_name":"IWC"},{"id":1061,"system_name":"luxury_watch_brand_illinois_watch_co","pretty_name":"Illinois Watch Co"},{"id":414,"system_name":"luxury_watch_brand_jacob_co","pretty_name":"Jacob \u0026 Co."},{"id":415,"system_name":"luxury_watch_brand_jaeger_lecoultre","pretty_name":"Jaeger-LeCoultre"},{"id":416,"system_name":"luxury_watch_brand_jaquet_droz","pretty_name":"Jaquet-Droz"},{"id":417,"system_name":"luxury_watch_brand_kobold","pretty_name":"Kobold"},{"id":418,"system_name":"luxury_watch_brand_lange_söhne","pretty_name":"Lange \u0026 Söhne"},{"id":1069,"system_name":"luxury_watch_brand_lloyd_watch_co","pretty_name":"Lloyd Watch Co"},{"id":419,"system_name":"luxury_watch_brand_longines","pretty_name":"Longines"},{"id":420,"system_name":"luxury_watch_brand_louis_vuitton","pretty_name":"Louis Vuitton"},{"id":421,"system_name":"luxury_watch_brand_mbf","pretty_name":"MB\u0026F"},{"id":1004,"system_name":"luxury_watch_brand_manometro","pretty_name":"Manómetro"},{"id":1149,"system_name":"luxury_watch_brand_maurice_lacroix","pretty_name":"Maurice Lacroix"},{"id":1281,"system_name":"luxury_watch_brand_michele","pretty_name":"Michele"},{"id":422,"system_name":"luxury_watch_brand_montblanc","pretty_name":"Montblanc"},{"id":423,"system_name":"luxury_watch_brand_moser","pretty_name":"Moser"},{"id":1064,"system_name":"luxury_watch_brand_movado","pretty_name":"Movado"},{"id":424,"system_name":"luxury_watch_brand_omega","pretty_name":"Omega"},{"id":1282,"system_name":"luxury_watch_brand_other","pretty_name":"Other"},{"id":425,"system_name":"luxury_watch_brand_panerai","pretty_name":"Panerai"},{"id":426,"system_name":"luxury_watch_brand_parmigiani","pretty_name":"Parmigiani"},{"id":427,"system_name":"luxury_watch_brand_patek_philippe","pretty_name":"Patek Philippe"},{"id":428,"system_name":"luxury_watch_brand_peter_speake_marin","pretty_name":"Peter Speake-Marin"},{"id":1268,"system_name":"luxury_watch_brand_philippe_charriol","pretty_name":"Philippe Charriol"},{"id":429,"system_name":"luxury_watch_brand_piaget","pretty_name":"Piaget"},{"id":1158,"system_name":"luxury_watch_brand_porsche_design","pretty_name":"Porsche Design"},{"id":786,"system_name":"luxury_watch_brand_raymond_weil","pretty_name":"Raymond Weil"},{"id":430,"system_name":"luxury_watch_brand_richard_mille","pretty_name":"Richard Mille"},{"id":431,"system_name":"luxury_watch_brand_roger_dubuis","pretty_name":"Roger Dubuis"},{"id":432,"system_name":"luxury_watch_brand_rolex","pretty_name":"Rolex"},{"id":433,"system_name":"luxury_watch_brand_seiko","pretty_name":"Seiko"},{"id":434,"system_name":"luxury_watch_brand_sinn","pretty_name":"Sinn"},{"id":435,"system_name":"luxury_watch_brand_tag_heuer","pretty_name":"TAG Heuer"},{"id":1148,"system_name":"luxury_watch_brand_tiffany","pretty_name":"Tiffany"},{"id":1157,"system_name":"luxury_watch_brand_tonino_lamborghini","pretty_name":"Tonino Lamborghini"},{"id":436,"system_name":"luxury_watch_brand_tudor","pretty_name":"Tudor"},{"id":437,"system_name":"luxury_watch_brand_ulysse_nardin","pretty_name":"Ulysse Nardin"},{"id":998,"system_name":"luxury_watch_brand_universal_geneve","pretty_name":"Universal Genève"},{"id":438,"system_name":"luxury_watch_brand_urwerk","pretty_name":"Urwerk"},{"id":1066,"system_name":"luxury_watch_brand_van_cleef_arpels","pretty_name":"Van Cleef \u0026 Arpels"},{"id":1062,"system_name":"luxury_watch_brand_waltham","pretty_name":"Waltham"},{"id":439,"system_name":"luxury_watch_brand_vacheron_constantin","pretty_name":"Vacheron Constantin"},{"id":440,"system_name":"luxury_watch_brand_zenith","pretty_name":"Zenith"}],
    genders: [{"id":718,"system_name":"luxury_watch_gender_man","pretty_name":"Man"},{"id":719,"system_name":"luxury_watch_gender_woman","pretty_name":"Woman"},{"id":1280,"system_name":"luxury_watch_gender_unisex","pretty_name":"Unisex"}],
    setting: [{"id":256,"system_name":"jewelry_style_ring_solitaire","pretty_name":"Solitaire"},{"id":257,"system_name":"jewelry_style_ring_3_stone","pretty_name":"3 Stone"},{"id":258,"system_name":"jewelry_style_ring_3_stone_uniform","pretty_name":"3 Stone (Uniform)"},{"id":259,"system_name":"jewelry_style_ring_central_cluster","pretty_name":"Central Cluster"},{"id":260,"system_name":"jewelry_style_ring_blossom_cluster","pretty_name":"Blossom Cluster"},{"id":261,"system_name":"jewelry_style_ring_halo","pretty_name":"Halo"},{"id":262,"system_name":"jewelry_style_ring_promise","pretty_name":"Promise"},{"id":263,"system_name":"jewelry_style_ring_right_hand","pretty_name":"Right Hand"},{"id":264,"system_name":"jewelry_style_ring_bridal_set","pretty_name":"Bridal Set"},{"id":265,"system_name":"jewelry_style_ring_eternity_band","pretty_name":"Eternity Band"},{"id":266,"system_name":"jewelry_style_ring_mens_ring","pretty_name":"Men’s Ring"},{"id":267,"system_name":"jewelry_style_ring_other","pretty_name":"Other"}]
}

export const FILTERS_VERSION = 2;

export const SHAPES = {
    jewelry: ['Round', 'Princess', 'Radiant', 'Marquise', 'Emerald', 'Pear', 'Asscher', 'Cushion', 'Oval'],
    other: [] // we'll fill these from the server
};

export const SLIDERS_DATA = {
    clarity: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3'],
    color: ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-Z']
};

export const STRING_OPTIONS = ['shape', 'certificate', 'jewelry_brand', 'brand', 'gender', 'main_subset_type', 'color', 'clarity'];
export const RANGE_OPTIONS = ['color', 'clarity', 'carat_weight'];
export const SETTING_OPTIONS = ['Solitaire', 'Bridal Set', '3 Stone', 'Halo', 'Other'];

// structured as rows of filters
// we use the singular form here, it matches the keys on filterProps,
//  and the plural form on filterOptions

export const FILTERS_BY_ROUTE = {
    diamonds: [
        ['certificate'],
        ['shape'],
        ['carat_weight', 'clarity', 'color']
    ],
    jewelry: [
        ['jewelry_type', 'jewelry_brand', 'certificate'],
        ['shape'],
        ['carat_weight', 'clarity', 'color']
    ],
    watches: [
        ['brand', 'gender']
    ],
    all: []
};


export const DEFAULT_FILTERS = {
    main_subset_type_in: 'All',
    jewelry_brand_in: 'All',
    certificate_in: 'All',
    shape_in: 'All',
    carat_weight_from: 0.10,
    carat_weight_to: 20.00,
    clarity_from: 0,
    clarity_to: SLIDERS_DATA['clarity'].length - 1,
    clarity_in: SLIDERS_DATA.clarity.reduce((acc, cur, i, src) => {  // Actual values should be the displayed values plus
        acc.push(clarity_values[cur], avg_clarity_values[cur]); // interim. i.e. FL-IF, I2-I3 etc. the reduce
        if (src.length > i + 1) {                               // function accumulates existing values and adds the
            const rangeVal = clarity_values[cur + "-" + src[i + 1]];   // interim.
            if (rangeVal) {
                acc.push(rangeVal, avg_clarity_values[cur + "-" + src[i + 1]])
            }
        } else {
            let prev = cur.split('-')[0];
            let lastValues = [avg_clarity_values[prev], clarity_values[prev], clarity_values[src[i - 1] + "-" + prev], avg_clarity_values[src[i - 1] + "-" + prev]];
            acc = acc.concat(lastValues);
        }
        return acc
    }, []),
    color_from: 0,
    color_to: SLIDERS_DATA['color'].length - 1,
    color_in: SLIDERS_DATA.color.reduce((acc, cur, i, src) => {
        acc.push(color_values[cur], avg_color_values[cur]);
        if (src.length > i + 1) {
            let rangeVal = color_values[cur + "-" + src[i + 1]];
            if (rangeVal) {
                acc.push(rangeVal, avg_color_values[cur + "-" + src[i + 1]])
            }
        } else {
            let prev = cur.split('-')[0];
            let lastValues = [avg_color_values[prev], color_values[prev], color_values[src[i - 1] + "-" + prev], avg_color_values[src[i - 1] + "-" + prev]];
            acc = acc.concat(lastValues);
        }
        return acc
    }, []),
    brand_in: 'All',
    gender_in: 'All'
};

export const ROUTE_TO_FILTER = {
    watches: 'luxury_watches'
};

// the values here match the 'filter' key in filterProps

export const ROUTE_FILTER_KEYS = {
    jewelry: ['main_subset_type', 'jewelry_brand', 'certificate', 'shape', 'carat_weight', 'clarity', 'color'],
    diamonds: ['shape', 'carat_weight', 'clarity', 'color', 'certificate'],
    watches: ['brand', 'gender'],
    all: [],
    in_prog: []
};


// TODO: move to CMS
// the 'filter' key here matches the values in ROUTE_FILTER_KEYS
export const FILTER_PROPS = {
    jewelry_type: {
        type: 'select',                       // type: used for rendering
        filter: 'main_subset_type',           // filter: system name for server ajax
        label: 'JEWELRY TYPE',                // label: display label
    },
    jewelry_brand: {
        type: 'select',
        filter: 'jewelry_brand',
        label: 'BRAND',
    },
    brand: {
        type: 'select',
        filter: 'brand',
        label: 'BRAND',
    },
    gender: {
        type: 'select',
        filter: 'gender',
        label: 'GENDER',
    },
    certificate: {
        type: 'select',
        filter: 'certificate',
        label: 'CERTIFICATE',
    },
    shape: {
        type: 'flat',
        filter: 'shape',
        label: 'SHAPE'
    },
    carat_weight: {
        type: 'slider',
        subtype: 'numeric',
        filter: 'carat_weight',
        label: 'CARAT'
    },
    clarity: {
        type: 'slider',
        subtype: 'letter',
        filter: 'clarity',
        label: 'CLARITY'
    },
    color: {
        type: 'slider',
        subtype: 'letter',
        filter: 'color',
        label: 'COLOR'
    }
};

import FilterSlider from '../partners/filter_slider';
import FilterFlat from '../partners/filter_flat';
import FilterSelect from '../partners/filter_select';

export const TYPE_TO_COMPONENT = {
    select: FilterSelect,
    flat: FilterFlat,
    slider: FilterSlider
};

export const ANIM_TIMEOUT_DELAY = 500; // this must match CSS transition time (at least)

// Expand 'group' filters, e.g clarity => clarity_from, clarity_to, clarity_range
//      this lets us simplify the data structure
// TODO: move logic to hash
export const getFilterKeysForRoute = (route) => {
    let relevantKeys = ROUTE_FILTER_KEYS[route];

    if (!relevantKeys) return;
    let filters = deepClone(relevantKeys);

    _.each(relevantKeys, (key) => {
        // 'group' props
        if (_.includes(RANGE_OPTIONS, key)) {
            filters.push(key + '_from');
            filters.push(key + '_to');
        }
        if (_.includes(STRING_OPTIONS, key)) {
            filters.push(key + '_in');
        }
    });

    return filters;
};

export const elementRect = function (el) {
    let $el = $(el).clone(), rect;

    $el.css({height: 'auto', position: 'absolute', opacity: 0, top: -9999})
        .attr('style', 'max-height: 9999px !important').appendTo($(el).parent());
    rect = $el.get(0).getBoundingClientRect();
    $el.remove();

    return {
        height: rect.height,
        width: rect.width
    }
};

export const isMobile = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

export const isTablet = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
};

export const goTo = function(url) {
    window.location.assign(url)
};

export const noValueStr = '\u2500';

const padZero = function(x) {
    return `${'00'.slice(x.toFixed(0).length)}${x}`
};

// format time left for auction
// - when under 24 hours show time left in H:M
// - else show date in DD/MM/YY
export const timeLeft = function(str, date_only) {
    let d = new Date(str),
        diff = d - (new Date()),
        inSecs = diff / 1000,
        inMins = inSecs / 60,
        mins = inMins % 60,
        hours = inMins / 60,
        hourStr = hours >= 1 ? `${Math.floor(hours)}h ` : '',
        soonStr = `${hourStr}${Math.floor(mins)}m`,
        dateStr = `${padZero(d.getMonth()+1)}/${padZero(d.getDate())}/${(d.getFullYear()+'').slice(2)}`,
        finalStr = (hours >= 24 || date_only) ? dateStr : soonStr
    ;

    return (diff > 0 || date_only) && finalStr;
};

export const timeLeftForAuctions = function(str, date_only) {
    const d = new Date(str),
        diff = d - (new Date()),
        inSecs = diff / 1000,
        inMins = inSecs / 60,
        mins = inMins % 60,
        hours = inMins / 60,
        hourStr = hours >= 1 ? `${Math.floor(hours)}h ` : '',
        soonStr = `${hourStr}${Math.floor(mins)}m`,
        dateStr = `${padZero(d.getMonth()+1)}/${padZero(d.getDate())}/${(d.getFullYear()+'').slice(2)}`,
        finalStr = (hours >= 24 || date_only) ? {isLess: false, value: dateStr} : {isLess: true, value: soonStr}
    ;

    return (diff > 0 || date_only) && finalStr;
};

const actionBtn = <span className="btn btn-action">UPDATE BID</span>,
    auctionEndedText = 'ENDED';

export const ItemColVal = function(val, field, item, showEndedStr) {
    switch(field) {
        case 'end_time':
            val = showEndedStr && !item.active ? auctionEndedText : timeLeft(val);
            break;
        case 'ended_on':
            val = timeLeft(val, true);
            break;
        case 'lead_bid':
        case 'your_bid':
            val = formatCurrency(val);
            break;
        case 'addl':
            val = val ? 'Yes' : 'No';
            break;
        case 'item_type':
            val = val || item['stone_type'];
            break;
        case 'action':
            val = item.action ? actionBtn : '';
            break;
        case 'min_price_met':
            val = item.min_price_met ? 'Met' : 'Not Met';
            break;
        case 'position':
            val = positionTexts[val].text
    }

    return val;
};

export const fieldToSysName = {
    watch_brand: 'brand',
    watch_gender: 'gender'
};

export const positionTexts = {
    in_the_lead: {
        text: "In the lead",
        classname: 'text-success'
    },
    outbid: {
        text: "Outbid",
        classname: 'text-danger'
    },
    won: {
        text: "Won",
        classname: 'text-success'
    },
    didnt_win: {
        text: "Didn't win",
        classname: ''
    },
    pending: {
        text: "Pending",
        classname: ''
    },
};


export const sortByKey = function(hay, needle, desc) {
    // we use deepClone for immutability; sort alters original object
    let newHay = deepClone(hay),
        clarity = deepClone(SLIDERS_DATA['clarity'])
    ;
    newHay.sort(function(p, n) {
        let pk = p[needle] || '', nk = n[needle] || ''; 

        if(pk === nk) return 0;

        if(needle === 'clarity') {
            let pkS = pk.split('-'),
                nkS = nk.split('-'),
                pkI, nkI
            ;
            pkI = clarity.indexOf(pkS[0]);
            nkI = clarity.indexOf(nkS[0]);
            // if low range diff: use index cmp, otherwise: stay with str cmp
            // SI1-SI2      # idx: 6
            // I1           # idx: 8
            // 6 < 8        # ST1 < I1
            //
            // VVS1-VVS2    # idx: 2
            // VVS1         # idx: 2
            // VVS1 < VVS1-VVS2 # 2 == 2
            if(pkI !== nkI) {
                pk = pkI;
                nk = nkI;
            }
        }
        // shouldn't be needed, but just in case we have a number dressed
        //    up as a string
        // the damned thing converts '' => 0, not good when dealing with strings,
        // disable the feature for now
        // else if(typeof(pk) !== 'Number' && !isNaN(pk)) {
        //     pk = Number(pk);
        //     nk = Number(nk);
        // }
        // return pk.localeCompare(nk) * (desc ? -1 : 1); // doesn't work with numbers
        return (pk < nk ? -1 : 1) * (desc ? -1 : 1);
    });
    return newHay;
};

// humanize field names, used in table headers etc
export const columnTexts = {
    didnt_win: {
        lead_bid: "HIGHEST BID",
        end_time: "ENDED ON",
    },
    won: {
        lead_bid: "WINNING BID",
    },
    'default': {
        item_type: "TYPE",
        addl: "ADDL. D",
        id: "NUMBER",
        orig_box: "BOX & DOCS",
        lead_bid: "LEAD. BID",
        end_time: "ENDING",
        min_price_met: 'RESERVE PRICE',
        action: 'TAKE ACTION'
    }
};

export const isElementVisible = function (el) {
    let topView = $(window).scrollTop(),
        view = topView + $(window).height(),
        topElement = $(el).offset().top,
        element = topElement + $(el).height();

    return ((element <= view) && (topElement >= topView))
};


export const isElementInViewport = function (el) {

    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    } 
    else if (el.current) {
        el = el.current;
    }

    const rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
};

export const deepClone = function(obj) {
    return JSON.parse(JSON.stringify(obj));
};

export const setDeepState = function (callback) {
    let nextState = callback(deepClone(this.state));
    this.setState(nextState);
};

export const formatCurrency = function(n) {
    return n && `$${n.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
};

export const ripple = function (e) {

    // Remove any old one
    $(".ripple").remove();

    // Setup
    let $this = $(e.currentTarget),
        posX = $this.offset().left,
        posY = $this.offset().top,
        buttonWidth = $this.width(),
        buttonHeight = $this.height(),
        $ripple = $("<span class='ripple'/>");

    // Add the element
    $this.prepend($ripple);

    // Make it round!
    if (buttonWidth >= buttonHeight) {
        buttonHeight = buttonWidth;
    } else {
        buttonWidth = buttonHeight;
    }

    // Get the center of the element
    let x = e.pageX - posX - buttonWidth / 2;
    let y = e.pageY - posY - buttonHeight / 2;


    // Add the ripples CSS and start the animation
    $ripple.css({
        width: buttonWidth,
        height: buttonHeight,
        top: y + 'px',
        left: x + 'px'
    }).addClass("rippleEffect");
};

export const texts = {
    auctions: "auctions",
    clear_filters: "Clear filters",
    sort_by: "Sort by",
    shapes_selected: {
        plural: "shapes selected",
        single: "shape selected"
    },
    button_X: "Done"
};

export const getGACategory = (path) => {
    return path.search('myAuctions') > -1 ? 'My Auctions' : 'Auction Center';
}

export const GA_ACTION = {
    AuctionClicked: "Auction Clicked",
    FiltersOpened: "Filters Opened"
}